import {
  getIntendType,
  getCookie,
  getSession,
  viewport,
  isJointTransactionFlow,
  getJointTransactionLine,
  renderHTML,
} from '../../../common/Helpers/index';
import { checkoutLabels } from '../Components/labels';

export const addRemoveAccessoriesPayload = (value = {}) => {
  const removeAccessories = value.data?.removeAccessories && [
    {
      id: value.data?.removeAccessories ? value.data?.removeAccessories.prodId : '',
      qty: value.data?.removeAccessories ? value.data?.removeAccessories.qty : '',
      isSoftSku: false,
      accessoryBundle: false,
    },
  ];
  const addAccessories = value.data?.addAccessories && [
    {
      id: value.data?.addAccessories ? value.data?.addAccessories.prodId : '',
      qty: value.data?.addAccessories ? value.data?.addAccessories.qty : '',
      isSoftSku: false,
      accountLevelAccessory: false,
    },
  ];
  const joint = isJointTransactionFlow();
  const line = joint ? `${getJointTransactionLine()}` : 'newLine1';
  let postData = {
    cartInfo: {
      correlationId: '',
      processingMTN: line,
      processStep: 'Accessories',
      cartCreator: '',
      processAction: 'addAccessory',
      intendType: `${getIntendType()}`,
      intent: `${getIntendType()}`,
      creditAppNum: '',
    },
    data: {
      depletionType: value?.data?.depletionType,
      lines: [
        {
          mtn: line,
          mdnFilterValue: line,
          removeAccessories,
          addAccessories,
          ispuFlow: false,
          depletionLocationCode: '',
        },
      ],
    },
  };
  if (value === 'WHW') {
    postData = {
      cartInfo: {
        correlationId: '',
        processingMTN: viewport() === 'mfapp' ? getCookie('whwProcessingMTN') : getSession('whwProcessingMTN'),
        processStep: 'AccessoryPDP',
        cartCreator: '',
        processAction: 'addAccessoryAndCheckout',
        intendType: 'ACC',
        intent: `RedemptionAccessory`,
        creditAppNum: '',
        flowType: 'WHW_Redemption',
      },
      data: {
        depletionType: 'F',
        lines: [
          {
            mtn: viewport() === 'mfapp' ? getCookie('whwProcessingMTN') : getSession('whwProcessingMTN'),
            mdnFilterValue: '',
            addAccessories: [
              {
                qty: '1',
                isSoftSku: false,
                accessoryBundle: false,
                giftCard: false,
                category: 'Gaming & Toys',
                productId: '',
                accountLevelAccessory: false,
                scannedItem: false,
                cashOptionEnabled: false,
                id: viewport() === 'mfapp' ? getCookie('routerSku') : getSession('routerSku'),
                offerId: viewport() === 'mfapp' ? getCookie('offerId') : getSession('offerId'),
                offerType: viewport() === 'mfapp' ? getCookie('offerType') : getSession('offerType'),
              },
            ],
            ispuFlow: false,
            depletionLocationCode: '',
          },
        ],
      },
    };
  }
  if (value.value === 'WHWExtender') {
    postData = {
      cartInfo: {
        correlationId: '',
        processingMTN: viewport() === 'mfapp' ? getCookie('whwProcessingMTN') : getSession('whwProcessingMTN'),
        processStep: 'AccessoryPDP',
        cartCreator: '',
        processAction: 'addAccessoryAndCheckout',
        intendType: 'ACC',
        intent: `RedemptionAccessory`,
        creditAppNum: '',
        flowType: 'WHW_Redemption',
      },
      data: {
        depletionType: 'F',
        lines: [
          {
            mtn: viewport() === 'mfapp' ? getCookie('whwProcessingMTN') : getSession('whwProcessingMTN'),
            mdnFilterValue: '',
            addAccessories: [
              {
                qty: value?.qty,
                isSoftSku: false,
                accessoryBundle: false,
                giftCard: false,
                category: 'Gaming & Toys',
                productId: '',
                accountLevelAccessory: false,
                scannedItem: false,
                cashOptionEnabled: false,
                id: value?.routerSku,
                spoId: value?.spoId,
              },
            ],
            ispuFlow: false,
            depletionLocationCode: '',
          },
        ],
      },
    };
  }
  return postData;
};

export const removeCartItemPayload = (value = {}) => {
  let postData;
  if (value.description === 'VIDEO') {
    const remove = value.removeYtTv && [
      {
        itemId: value?.removeYtTv?.prodId,
        name: value?.removeYtTv?.name,
        description: 'VIDEO',
        pricePlanId: value?.removeYtTv?.pricePlanId,
        price: value?.removeYtTv?.price,
        contentId: 'YTTVBASIC',
        actionIndicator: 'Z',
        recurringInd: value?.removeYtTv?.recurringInd,
      },
    ];

    postData = {
      cartInfo: {
        processAction: 'addAccessory',
        processingMTN: isJointTransactionFlow() ? `${getJointTransactionLine()}` : 'newLine1',
        processStep: 'Accessories',
        cartCreator: '',
        intendType: `${getIntendType()}`,
        creditAppNum: '',
      },
      data: {
        isSubscription: true,
        account: {
          mcsSubscription: {
            remove,
          },
        },
      },
    };
  }

  if (value?.cartItemType === 'DEVICE') {
    postData = {
      cartInfo: {
        clientAppName: 'VZW-DOTCOM',
        creditAppNum: '',
        processingMTN: 'newLine2',
        processStep: 'ShoppingCart',
        intendType: `${getIntendType()}`,
        processAction: 'removeItem',
      },
      data: {
        lines: [
          {
            mtn: 'newLine2',
          },
        ],
      },
    };
  }

  return postData;
};

export const promoCodePayload = (data = '') => {
  const postData = {
    cartInfo: {
      clientAppName: 'VZW-DOTCOM',
      intendType: `${getIntendType()}`,
      processStep: 'ShoppingCart',
      processAction: 'addPromoCode',
    },
    data: {
      couponCode: data,
    },
  };
  return postData;
};

export const getPaymentDetails = (payment) => {
  let title;
  if (payment.AC && payment.AC?.paymentType === 'AC') {
    // Bill to my verizon account
    title = checkoutLabels.BTA;
  } else if (payment.CR && payment.CR?.paymentType === 'CR') {
    // Cards
    title = `${payment.CR?.creditCardDetails?.creditCardType ? payment.CR?.creditCardDetails?.creditCardType?.toUpperCase() : 'Card'}
    ending in ${payment.CR?.creditCardDetails && payment.CR?.creditCardDetails?.cardNumber?.replace(/\s+/g, '').substr(-4)}`;
  } else {
    // Paypal
    const paypalPayment = payment.PY || payment.PAYPAL;
    title = renderHTML(
      `${paypalPayment?.paymentType}<br/>${paypalPayment?.paypalPaymentDetails?.paypalPaymentAuthenticateDetails?.paypal_processorUserEmail}`,
    );
  }
  return title;
};
